<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="模板名称">
              <a-input
                v-model="queryParam.templateName"
                placeholder="请输入模板名称"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="模板类型">
              <j-dict-select-tag
                v-model="queryParam.templateType"
                placeholder="请选择模板类型"
                dictCode="template_type"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus"
        >新建消息模板</a-button
      >
      <a-button @click="handleSynchronousFans" type="primary"
        >同步粉丝</a-button
      >
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
          <!--<a-menu-item key="2" @click="changeStatus('1')">批量启用</a-menu-item>-->
          <!--<a-menu-item key="3" @click="changeStatus('0')">批量停用</a-menu-item>-->
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            alt=""
            style="width: 80px; height: 40px"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a
            v-if="record.templateType === '1'"
            @click="sendMessagePreview(record)"
            >预览</a
          >
          <a-divider v-if="record.templateType === '1'" type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDelete(record.id)">删除</a>
              </a-menu-item>
              <a-menu-item v-if="record.templateType === '1'">
                <a @click="sendMessageAll(record)">粉丝推送</a>
              </a-menu-item>
              <a-menu-item v-if="record.templateType === '1'">
                <a @click="sendMessageAllDetail(record)">粉丝推送详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="sendMessageSubscribe(record)">订阅推送</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="sendMessageSubDetail(record)">订阅推送详情</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <a-modal v-model="isSend" title="推送预览" @ok="sendMessagePreviewOk">
      <a-form :form="form">
        <a-form-item label="请选择支付宝用户">
          <j-dict-select-tag
            v-decorator="[
              'userId',
              { rules: [{ required: true, message: '请选择支付宝用户' }] },
            ]"
            :triggerChange="true"
            placeholder="请选择支付宝用户"
            dictCode="zfb_user_id"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      style="position: relative"
      v-model="isShowMessage"
      title="推送详情"
      @ok="handleMessageOk"
    >
      <a-spin style="position: absolute; top: 50%; left: 50%" v-if="isSpin" />
      <p>总用户数量：{{ messageDetail.total }}</p>
      <p>推送成功：{{ messageDetail.success }}</p>
      <p>推送失败：{{ messageDetail.fail }}</p>
      <p>尚未推送：{{ messageDetail.surplus }}</p>
    </a-modal>
    <message-template-modal
      ref="modalForm"
      @ok="modalFormOk"
    ></message-template-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
// import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import MessageTemplateModal from './modules/MessageTemplateModal';
import { putAction, getAction, postAction } from '../../../api/manage';
import JImageUpload from '@/components/jeecg/JImageUpload';
import pick from 'lodash.pick';
import customRender from '@/utils/customRender.js';

// function getBase64(img, callback) {
//   const reader = new FileReader();
//   reader.addEventListener('load', () => callback(reader.result));
//   reader.readAsDataURL(img);
// }

export default {
  //el 创建前
  beforeCreate() {
    //创建表单
    this.form = this.$form.createForm(this, { name: 'previewForm' });
  },
  name: 'MessageTemplate',
  mixins: [JeecgListMixin],
  components: {
    MessageTemplateModal,
    JImageUpload,
  },
  data() {
    return {
      isSpin: false,
      previewForm: {
        templateId: '',
        userId: '',
      },
      isSend: false,
      isShowMessage: false,
      messageDetail: {},
      description: '消息模板管理页面',
      loading: false,
      upload:
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_FILE_UPLOAD +
        '/upload',
      stopImgShow: false,
      stopTextShow: false,
      stopJumpShow: false,
      stopType: '0',
      stopFlag: false,
      confirmLoading: false,
      maintainImg: '',
      activityDescribe: '',
      jumpUrl: '',
      modelId: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      // 表头
      columns: [
        /*  {
            title:'模板ID',
            align:"center",
            dataIndex: 'messageId',
            customRender:function (text) {
              return !text?"":(text.length>12?text.substr(0,12)+"...":text)
            }
          },*/
        {
          title: '模板名称',
          align: 'center',
          dataIndex: 'templateName',
          ellipsis: true,
          // customRender: function (text) {
          //   return !text
          //     ? ''
          //     : text.length > 12
          //     ? text.substr(0, 12) + '...'
          //     : text;
          // },
        },
        /* {
            title:'关联活动',
            align:"center",
            dataIndex: 'associateActivity',
          },*/
        {
          title: '模板标题',
          align: 'center',
          dataIndex: 'firstTitle',
          ellipsis: true,
          customRender: customRender,
          // customRender: function (text) {
          //   return !text
          //     ? '--'
          //     : text.length > 12
          //     ? text.substr(0, 12) + '...'
          //     : text;
          // },
        },
        /* {
            title:'跳转地址',
            align:"center",
            dataIndex: 'jumpUrl',
            customRender:function (text) {
              return !text?"":(text.length>12?text.substr(0,12)+"...":text)
            }
          },
          {
            title:'模板关键词1',
            align:"center",
            dataIndex: 'keyword1',
            customRender:function (text) {
              return !text?"":(text.length>12?text.substr(0,12)+"...":text)
            }
          },
          {
            title:'模板关键词2',
            align:"center",
            dataIndex: 'keyword2',
            customRender:function (text) {
              return !text?"":(text.length>12?text.substr(0,12)+"...":text)
            }
          },
          {
            title:'模板关键词3',
            align:"center",
            dataIndex: 'keyword3',
            customRender:function (text) {
              return !text?"":(text.length>12?text.substr(0,12)+"...":text)
            }
          },
          {
            title:'模板备注',
            align:"center",
            dataIndex: 'remark',
            customRender:function (text) {
              return !text?"":(text.length>12?text.substr(0,12)+"...":text)
            }
          },*/
        {
          title: '模板类型',
          align: 'center',
          dataIndex: 'templateType_dictText',
          customRender: customRender,
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      dataSource: [],
      /* 分页参数 */
      url: {
        list: process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/list',
        delete: process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/delete',
        edit: process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/edit',
        deleteBatch:
          process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/deleteBatch',
        updateStatus:
          process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/updateStatus',
        sendMessagePreview:
          process.env.VUE_APP_CMS_MARKETING +
          '/messageTemplate/sendMessagePreview',
        sendMessageSubscribe:
          process.env.VUE_APP_CMS_MARKETING +
          '/messageTemplate/sendMessageSubscribe',
        sendMessageAll:
          process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/sendMessageAll',
        sendMessageAllDetail:
          process.env.VUE_APP_CMS_MARKETING +
          '/messageTemplate/sendMessageAllDetail',
        getFans: process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/getFans',
        sendMessageSubDetail:
          process.env.VUE_APP_CMS_MARKETING +
          '/messageTemplate/sendMessageSubDetail',
      },
      dictOptions: {},
    };
  },
  computed: {},
  methods: {
    initDictConfig() {},
    // 单个删除
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    // 批量删除
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData(1);
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    //批量启用、停用
    changeStatus(num) {
      var title_tmp = '';
      var content_tmp = '';
      if (num === '1') {
        title_tmp = '确认启用';
        content_tmp = '是否启用选中数据';
      } else {
        title_tmp = '确认停用';
        content_tmp = '是否停用选中数据';
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (let i = 0; i < this.selectedRowKeys.length; i++) {
          ids += this.selectedRowKeys[i] + ',';
        }
        var that = this;
        this.$confirm({
          title: title_tmp,
          content: content_tmp,
          onOk: function () {
            that.loading = true;
            putAction(that.url.updateStatus, { ids: ids, type: num })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  //刷新页面
                  that.loadDataTmp();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },

    //启用、停用
    handleChange(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要停用所选数据?';
      var that = this;
      var type = record.status === '1' ? '0' : '1';
      this.$confirm({
        title: record.status === '1' ? '停用' : '启用',
        content: record.status === '1' ? strClose : strOpen,
        onOk() {
          that.modelId = record.id;
          that.stopFlag = false;
          putAction(that.url.updateStatus, { ids: record.id, type: type }).then(
            (res) => {
              if (res.success) {
                //刷新页面
                that.loadDataTmp();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            }
          );
        },
      });
    },

    isChecked(statusTemp) {
      if (statusTemp === '1') {
        return true;
      } else return false;
    },

    loadDataTmp() {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      this.loading = true;
      getAction(this.url.list).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },

    handleStopCancel() {
      this.$emit('close');
      this.stopFlag = false;
      this.stopImgShow = false;
      this.stopTextShow = false;
      this.stopJumpShow = false;
    },

    handleStopOk() {
      const that = this;
      that.confirmLoading = true;
      let httpurl = that.url.edit;
      let method = 'put';
      let submitData = {
        id: that.modelId,
        status: '0',
        stopType: that.stopType,
        maintainImg: that.maintainImg,
        activityDescribe: that.activityDescribe,
        jumpUrl: that.jumpUrl,
      };
      putAction(httpurl, submitData, method)
        .then((res) => {
          if (res.success) {
            that.loadDataTmp();
            that.$message.success(res.message);
            that.$emit('ok');
          } else {
            that.$message.warning(res.message);
          }
        })
        .finally(() => {
          that.confirmLoading = false;
          that.$emit('close');
          that.stopFlag = false;
          that.stopImgShow = false;
          that.stopTextShow = false;
          this.stopJumpShow = false;
        });
    },

    fieldValue(e) {
      if (e === '1') {
        this.stopTextShow = true;
        this.stopImgShow = false;
        this.stopJumpShow = true;
      } else if (e === '2') {
        this.stopImgShow = true;
        this.stopTextShow = false;
        this.stopJumpShow = true;
      } else {
        this.stopImgShow = false;
        this.stopTextShow = false;
        this.stopJumpShow = false;
      }
    },

    handleChangeUpload(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        /*getBase64(info.file.originFileObj, imageUrl => {
            this.maintainImg = imageUrl;
            this.loading = false;
          });*/

        info.file.url = info.file.response.result.url;
        this.maintainImg = info.file.response.result.url;
        return info.file;
      }
    },
    beforeUpload: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      }
    },
    sendMessageSubscribe(record) {
      var that = this;
      this.$confirm({
        title: '订阅推送',
        content: '确定推送消息给所有订阅粉丝吗？此过程可能耗时较长',
        onOk() {
          postAction(that.url.sendMessageSubscribe, {
            templateId: record.id,
          }).then((res) => {
            if (res.success) {
              //刷新页面
              that.loadDataTmp();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },
    sendMessageAll(record) {
      var that = this;
      this.$confirm({
        title: '粉丝推送',
        content: '确定推送消息给所有粉丝吗？此过程可能耗时较长',
        onOk() {
          postAction(that.url.sendMessageAll, { templateId: record.id }).then(
            (res) => {
              if (res.success) {
                //刷新页面
                that.loadDataTmp();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            }
          );
        },
      });
    },
    sendMessageAllDetail(record) {
      this.isShowMessage = true;
      this.isSpin = true;
      this.messageDetail = {};
      getAction(this.url.sendMessageAllDetail, { templateId: record.id }).then(
        (res) => {
          if (res.success) {
            this.isSpin = false;
            this.messageDetail = res.result;
            console.log(this.messageDetail);
            console.log(res.data);
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },

    sendMessageSubDetail(record) {
      this.isShowMessage = true;
      this.isSpin = true;
      this.messageDetail = {};
      getAction(this.url.sendMessageSubDetail, { templateId: record.id }).then(
        (res) => {
          if (res.success) {
            this.isSpin = false;
            this.messageDetail = res.result;
            console.log(this.messageDetail);
            console.log(res.data);
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },

    handleMessageOk(e) {
      console.log(e);
      this.isShowMessage = false;
    },
    sendMessagePreview(record) {
      this.isSend = true;
      this.form.resetFields();
      this.model = Object.assign({}, record);

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'userId'));
      });
      this.previewForm = record;
    },
    sendMessagePreviewOk() {
      var that = this;
      this.$confirm({
        title: '消息预览推送',
        content: '确定推送消息给该支付宝用户吗？',
        onOk() {
          // 触发表单验证
          that.form.validateFields((err, values) => {
            if (!err) {
              let formData = Object.assign(that.model, values);
              postAction(that.url.sendMessagePreview, {
                templateId: that.previewForm.id,
                userId: formData.userId,
              }).then((res) => {
                if (res.success) {
                  //刷新页面
                  that.loadDataTmp();
                  that.$message.success(res.message);
                } else {
                  that.$message.error(res.message);
                }
                that.form.resetFields();
                that.isSend = false;
              });
            }
          });
        },
      });
    },
    handleSynchronousFans() {
      var that = this;
      this.$confirm({
        title: '同步粉丝',
        content: '确定要同步粉丝吗？此过程可能耗时较长',
        onOk() {
          getAction(that.url.getFans).then((res) => {
            if (res.success) {
              //刷新页面
              that.loadDataTmp();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
